import axios from 'axios'

export default{
    namespaced: true,
    state: {
        endpoint: '',
    },
    getters: {
       getEndpoint(state){
            return state.endpoint;
       }
    },
    mutations: {
        setEndpoint(state, endpoint) {
            state.endpoint = endpoint;
        }
    },
    actions: {

        getMarkSheetTerms () {
            let url = '/api/mark-sheet-terms';
            return axios.get(url);
        },
        
        getReportCardTerms () {
            let url = '/api/report-card-terms';
            return axios.get(url);
        },

        getClassListYears () {
            const url = '/api/class-list-years';
            return axios.get(url);
        },

        downloadASR () {
            const url = '/api/asr';
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer'
            })
        },

        downloadSpreadsheet ({ getters }){
            const url = getters.getEndpoint;
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer'
            })
        },

        getStudentPerformanceAcademicYears () {
            const url = '/api/student-performance/academic-years';
            return axios.get(url);
        },

        getStudentPerformanceSubjects () {
            const url = '/api/student-performance/subjects';
            return axios.get(url);
        },

        getStudentPerformanceFormClasses () {
            const url = '/api/student-performance/form-classes';
            return axios.get(url);
        },
    }
}    